export default __webpack_public_path__ + "static/bg2021-467d34dc0dd43287b90a5a1a0bf1bad1.jpg";